const HOTJAR_SUPPRESS_ATTR = 'data-hj-suppress';
const CLARITY_SUPPRESS_ATTR = 'data-clarity-mask';

const suppressDataBySelector = (selector: string): void => {
    const el = document.querySelector(selector);
    if (!el) return;

    // Microsoft Clarity masking
    el.setAttribute(CLARITY_SUPPRESS_ATTR, 'True');

    // Hotjar masking (deprecated - will be removed in future)
    el.setAttribute(HOTJAR_SUPPRESS_ATTR, '');
};

export const suppressClarityData = (selectors: string[]): void => {
    selectors.forEach((s) => suppressDataBySelector(s));
};
